import React from "react";
import { HiMiniChatBubbleBottomCenter } from "react-icons/hi2";


export default function CustomMapMarkerDriver({ text }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
      }}
    >
      <div
        style={{
          fontSize: "45px"
        }}
      >
        <HiMiniChatBubbleBottomCenter style={{ color: "#409E6A", position: 'relative' }} />
        <span
          style={{
            position: 'absolute',
            color: "#FFF",
            fontSize: "20px",
            fontWeight: 600,
            top: '16px', 
            left: '16px', 
          }}
        >{text}</span>
      </div>
    </div>
  )
}